import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import { fetchDeleteRole, fetchRoleList } from "../actions/role";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const RoleList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "roles";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { roleList } = useSelector((state) => state.roleReducer);

  useEffect(() => {
    dispatch(fetchRoleList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/role-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (id) => {
    dispatch(fetchDeleteRole(id));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("roleList.roleName"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: t("roleList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("roleList.inactive");
          case "ACTIVE":
            return t("roleList.active");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("roleList.creationDate"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("roleList.lastUpdatedDate"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={roleList}
        columnDefs={columnDefs}
        buttonLink={`/role-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"role-list"}
      />
    </Fragment>
  );
};

export default RoleList;
